module.exports = __webpack_public_path__ + "static/ERP-5cc023095a29725505d57dc9a620411c.svg";